import { Button, Img, Text } from "components";

const EmptyAllTab = (props) => {
  return (
    <>
      <div className="flex flex-col items-center justify-center py-16 px-6 w-full">

        <Img
          className="h-[140px] w-auto mb-6 object-contain"
          src="images/empltyLocation.svg"
          alt="order-empty"
        />

        <Text
          className="text-[20px] font-semibold text-black-900 font-['Inter'] leading-[28px] text-center mb-2"
        >
          {props?.emptyTitle}
        </Text>

        <Text
          className="text-[14px] font-normal text-gray-500 font-['Inter'] leading-[22px] text-center max-w-[260px] mb-6"
        >
          {props?.emptyParagraph}
        </Text>

        <button
          className="px-7 py-[11px] rounded-full text-[white] text-[14px] font-semibold font-['Inter'] tracking-wide cursor-pointer transition-opacity hover:opacity-90 flex items-center gap-2"
          style={{ backgroundColor: "#7B1A3C" }}
          onClick={() => props?.addAddressTrigger && props?.addAddressTrigger(0)}
        >
          <Img
            className="h-4 w-4 btn-icon brightness-0 invert"
            src="/images/img_plus_black_900_20x20.svg"
            alt="plus"
          />
          {props?.emptyBtn}
        </button>

        {/*
          ── COMMENTED: old border box wrapper ──
          <div className="border border-gray-300 border-solid flex flex-col items-center justify-end
                          p-[57px] md:px-10 sm:px-5 rounded w-full">
            ...
          </div>
        */}

        {/*
          ── COMMENTED: old Button component with OutlineBlack variant ──
          <Button
            variant={"OutlineBlack"}
            size={"md"}
            className="min-w-[125px] flex items-center justify-center"
            hover={true}
            hoverclass="bg-black-900"
            leftIcon={
              <Img
                className="h-5 mt-px btn-icon"
                src="/images/img_plus_black_900_20x20.svg"
                alt="plus"
              />
            }
            onClick={(e) => { props?.addAddressTrigger(0); }}
          >
            <Text className="mx-2" as="span">
              {props?.emptyBtn}
            </Text>
          </Button>
        */}
      </div>
    </>
  );
};

export default EmptyAllTab;